import { Icon } from '@iconify/react';
import peopleFill from '@iconify/icons-eva/people-fill';

import lineChartOutlined from '@iconify/icons-ant-design/line-chart-outlined';

import bxsChat from '@iconify/icons-bx/bxs-chat';
import planos from '@iconify/icons-uil/create-dashboard';

// ----------------------------------------------------------------------

const getIcon = (name) => <Icon icon={name} width={22} height={22} />;

const sidebarConfig = [
  {
    title: 'Dashboard',
    path: '/dashboard',
    icon: getIcon(lineChartOutlined)
  },
  {
    title: 'Utentes',
    path: '/utentes',
    icon: getIcon(peopleFill)
  },
  {
    title: 'Mensagens',
    path: '/mensagens',
    icon: getIcon(bxsChat)
  },
  {
    title: 'Planos',
    path: '/planos',
    icon: getIcon(planos)
  }
];

export default sidebarConfig;
